/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShortformInputs */



/**
* | output |
* | --- |
* | "Shortform" |
*
* @param {ShortformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform = /** @type {((inputs?: ShortformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShortformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abréviation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzform")
	if (locale === "it") return /** @type {LocalizedString} */ ("Versione abbreviata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Краткая форма")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato corto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("简体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त रूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Forma abreviada")
	return /** @type {LocalizedString} */ ("Shortform")
});